import { render, staticRenderFns } from "./AdminMilestoneTemplateButton.vue?vue&type=template&id=20a273b6"
import script from "./AdminMilestoneTemplateButton.vue?vue&type=script&lang=js"
export * from "./AdminMilestoneTemplateButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports